import { useMemo } from 'react';
import { generateEmptyDataPoints, processConsecutiveBatches, calculateStatsFromBatches } from '../utils/dataProcessors';

export const useChartData = (healthMetrics, timeRangeType) => {
  const chartData = useMemo(() => {
    // If no healthMetrics, generate empty data based on timeRangeType
    if (!healthMetrics?.metricsBatches) {
      return generateEmptyDataPoints([], timeRangeType);
    }
    
    const processedData = processConsecutiveBatches(healthMetrics.metricsBatches);
    return generateEmptyDataPoints(processedData, timeRangeType);
  }, [healthMetrics, timeRangeType]);

  const stats = useMemo(() => {
    return calculateStatsFromBatches(chartData);
  }, [chartData]);

  const hasData = useMemo(() => {
    return chartData.some(item => !item.isEmptyData);
  }, [chartData]);

  return {
    chartData,
    hasData,
    stats
  };
};





// import { useMemo } from 'react';
// import { generateEmptyDataPoints, processConsecutiveBatches, calculateStatsFromBatches } from '../utils/dataProcessors';

// export const useChartData = (healthMetrics, timeRangeType) => {
//   const chartData = useMemo(() => {
//     if (!healthMetrics?.metricsBatches) return [];
//     const processedData = processConsecutiveBatches(healthMetrics.metricsBatches);
//     return generateEmptyDataPoints(processedData, timeRangeType);
//   }, [healthMetrics, timeRangeType]);

//   const stats = useMemo(() => {
//     return calculateStatsFromBatches(chartData);
//   }, [chartData]);

//   const hasData = chartData.length > 0;

//   return {
//     chartData,
//     hasData,
//     stats
//   };
// };